import React from 'react';
import fr from 'facet-rest';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  SecondaryActionButtonRel,
} from 'Packages/FacetCore/Experimental/RelationshipComponents/SecondaryActionButtonRel';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDAccordionGroup,
  FDAccordion,
  FDAccordionTitle,
  FDAccordionDetails,
  FDStack,
  FDLozenge,
  FDSecondaryActionButton, FDBodyText,
} from '@facet-wealth/design';
import {
  householdEditRecordExpenseUri,
  householdEditRecordIncomeDetailsUri,
  householdEditRecordPersonalInformationUri, householdPayStubsUri,
} from 'Consts/advisorUris';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ReviewAccountStatementButton
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/BalanceSheet/UploadedAccountStatementsComponents/ReviewAccountStatementsButton';

const useStyles = buildUseStyles('MissingInformationSection', () => ({
  noExtraSpacing: {
    margin: 0,
    paddingLeft: '1.5em',
  },
}));

const getEditPropsByType = (listType, householdID) => ({
  Income: {
    href: householdEditRecordIncomeDetailsUri(householdID),
    openInNewTab: true,
    label: 'Edit income',
  },
  Expenses: {
    href: householdEditRecordExpenseUri(householdID),
    openInNewTab: true,
    label: 'Edit expenses',
  },
  Profile: {
    href: householdEditRecordPersonalInformationUri(householdID),
    openInNewTab: true,
    label: 'Edit profile',
  },
}[listType]);

export function MissingInformationSection() {
  const { resource } = useMetaLayoutContext();
  const listOfEntities = resource.attr('entities') ?? [];
  const listByType = resource.attr('byType')?.resources()?.list() ?? [];
  const { householdId } = useSimpleHousehold();
  const classes = useStyles();
  return (
    <FDStack padding={3} direction="column" alignItems="flex-start" spacing={2}>
      <FDStack direction="column" spacing={1}>
        <MetaControlField attr="title" />
        <MetaControlField attr="label" />
      </FDStack>
      <MetaControlField attr="description" />
      {listOfEntities.length > 0 && (
        <ul className={classes.noExtraSpacing}>
          {listOfEntities.map(entity => (
            <li key={entity}><FDBodyText value={entity} /></li>
          ))}
        </ul>
      )}
      {listByType.length > 0 && (
        <FDStack direction="column" width="100%" maxWidth={700}>
          <FDAccordionGroup>
            {listByType.map((list) => (
              <FDAccordion key={list.id()} expansionID={list.id()} gutters={false}>
                <FDAccordionTitle>
                  <FDStack direction="row" spacing={1} justifyContent="space-between" alignItems="center" flex={1}>
                    {list.attr('title')}
                    <FDLozenge label={list.attr('alert')} color="error" />
                  </FDStack>
                </FDAccordionTitle>
                <FDAccordionDetails>
                  <FDStack direction="column" spacing={3} alignItems="flex-start">
                    <ul className={classes.noExtraSpacing}>
                      {list.attr('entities').resources().list().map((entity, i) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <li key={i}>
                          <FDBodyText value={entity.attr('title')} />
                          <ul className={classes.noExtraSpacing}>
                            {entity.attr('issues').map((issue) => (<li key={issue}><FDBodyText value={issue} /></li>))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                    {list.withRelationship(
                      fr.relationships.edit.name,
                      (rel) => <SecondaryActionButtonRel relationship={rel} />,
                      () => <FDSecondaryActionButton {...getEditPropsByType(list.id(), householdId)} />,
                    )}
                  </FDStack>
                </FDAccordionDetails>
              </FDAccordion>
            ))}
          </FDAccordionGroup>
        </FDStack>
      )}
      <ReviewAccountStatementButton relationship={resource.relationship(fr.relationships.uploadedAccountStatements.name)} />
      <MetaControlField attr="payStubsLabel" />
      <MetaControlField attr="payStubsDescription" />
      {resource.withRelationship(fr.relationships.payStubs.name,
        () => (
          <FDSecondaryActionButton label="View paystubs" href={householdPayStubsUri(householdId)} openInNewTab />
        ),
        () => null)}
    </FDStack>
  );
}
